import type { AxiosInstance } from "axios";
import type { IFactoryFunctionRequest } from "@bc-library/interface";
import { EMethod } from "@bc-library/interface";
import { API_MAIN_VERSION, BASE_URL } from "@/config/constantes";
import useAxios from "@/services/api/useAxios";

const resource = "crmCustomFields";

export type CrmCustomFieldEntity = "company" | "engagement";
export type CrmCustomFieldType = "text" | "number" | "date" | "select" | "boolean";

export type CrmCustomField = {
  _id: string;
  entity: CrmCustomFieldEntity;
  key: string;
  label: string;
  fieldType: CrmCustomFieldType;
  options?: string[];
  isRequired?: boolean;
  order?: number;
};

export type CrmCustomFieldPayload = {
  entity: CrmCustomFieldEntity;
  key: string;
  label: string;
  fieldType: CrmCustomFieldType;
  options?: string[];
  isRequired?: boolean;
  order?: number;
};

const list =
  (axios: IFactoryFunctionRequest<any, any>) =>
  (query: Record<string, unknown> = {}) => {
    return axios({
      method: EMethod.get,
      url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
      query,
    });
  };

const getById = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
  });
};

const create = (axios: IFactoryFunctionRequest<any, any>) => (data: CrmCustomFieldPayload) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
    data,
  });
};

const update =
  (axios: IFactoryFunctionRequest<any, any>) =>
  (id: string, data: Partial<CrmCustomFieldPayload>) => {
    return axios({
      method: EMethod.patch,
      url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
      data,
    });
  };

const softDelete = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
  });
};

export default (axios: AxiosInstance) => ({
  list: list(useAxios(axios)),
  getById: getById(useAxios(axios)),
  create: create(useAxios(axios)),
  update: update(useAxios(axios)),
  softDelete: softDelete(useAxios(axios)),
});
